<div *ngIf="user_access_obj.includes(user_info_obj['role'])">
  <!-- <div *ngIf="user_access_obj.includes(user_info_obj['role'])" class="row m-4">
    <div class="col-md-3">
      <app-navbar
      (send_selected_from_search_dialog)="recieve_selected_multiple_items($event)"
      [allowMultipleSelect] = "true"></app-navbar>
    </div>
    <div class="col-md-4">
      <h1><i class="fa fa-cubes text-danger mr-1"></i>Systems Template <strong>Manager </strong>
      </h1>
    </div>
  </div> -->
  <div class="container-fluid">
    <mat-progress-bar *ngIf=" show_progressbar==true" class="mt-1"
                      mode="query"></mat-progress-bar>
    <mat-tab-group  (selectedTabChange)="click_get_conf_button();" mat-stretch-tabs class="mb-4 example-stretched-tabs " dynamicHeight>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon text-danger">settings_applications</mat-icon>
          Management
        </ng-template>
        <div class="m-4">

          <mat-horizontal-stepper #stepper>
            <mat-step [stepControl]="newTemplateForm">
              <form [formGroup]="newTemplateForm">
                <ng-template matStepLabel>Template selection</ng-template>
                <div class="d-flex justify-content-center">

                    <div class="col-md-9 col-sm-12">
                      <mat-card >
                        <div class="p-20 position-relative" style="background-color: darkgray;padding:'8px'; margin-bottom: 20px;">
                            <h4 class="card-title text-black m-0 ml-2">Templates list</h4>
                            <h6 class="card-subtitle text-black m-0 ml-2 op-5">Choose one of the templates</h6>
                            <button mat-mini-fab color="accent" class="add-contact"
                            style="background-color: #3f51b5;position: absolute !important;right: 17px;top: 36px;"
                            (click)="addNewTemplate=!addNewTemplate">+</button>
                        </div>
                        <div class="message-box contact-box p-20">
                            <div class="message-widget contact-widget">
                                <!-- Message -->
                                <div *ngFor="let row of distinct_templates;let i = index">
                                    <div class="mt-2" style="border-bottom: 1px lightgrey solid;">
                                      <mat-radio-button (change)="onCheck_assign_id(row)" [value]="row.id">
                                        {{row.template_name}}
                                      </mat-radio-button>
                                      <mat-icon class="example-tab-icon text-danger"
                                       style="position: absolute;right:0px;margin-right: 20px;cursor: pointer;"
                                       (click)="deleteTemplate(row.id)">delete</mat-icon>
                                    </div>
                                  </div>
                            </div>
                        </div>
                      </mat-card>
                  </div>

                  <div class="col-md-3 col-sm-12" *ngIf="addNewTemplate">
                    <h3>Create a new template profile</h3>
                    <mat-form-field>
                      <mat-label>Template Name</mat-label>
                      <input formControlName="template_name" matInput placeholder="ex.General Template..">
                    </mat-form-field>
                    <br>


                    <mat-form-field>
                      <mat-label>Description</mat-label>
                      <textarea formControlName="template_description" matInput placeholder="What is this?"></textarea>

                    </mat-form-field>
                    <br>
                    <button type="button" [disabled]="!newTemplateForm.valid" (click)="ngOnsubmit_save_new_template()"
                            color="primary" mat-raised-button>Save
                    </button>

                    <p *ngIf="template_id">({{template_id}}) template is ready, move to the next.</p>
                  </div>


                  <!-- <mat-accordion class="container ">
                    <mat-expansion-panel >
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          Templates list <span class="text-muted ml-2" *ngIf="template_name">({{template_name}})</span>
                        </mat-panel-title>
                        <mat-panel-description>
                          Choose from the saved templates
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      <mat-list>
                        <div mat-subheader>Current Templates</div>
                        <div class="treeview-scroller">
                          <mat-radio-group aria-label="Select an option">
                            <mat-list-item *ngFor="let row of distinct_templates;let i = index">
                              <mat-icon mat-list-icon>list_alt</mat-icon>
                              <div mat-line>
                                <mat-radio-button (change)="onCheck_assign_id(row)" [value]="row.id">
                                  {{i + 1}}- {{row.template_name}}
                                </mat-radio-button>
                              </div>
                              <div mat-line class="text-muted"> {{row.description}}</div>
                            </mat-list-item>
                          </mat-radio-group>
                          <mat-divider></mat-divider>
                        </div>

                      </mat-list>
                    </mat-expansion-panel>
                    <mat-expansion-panel>

                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          New Template
                        </mat-panel-title>
                        <mat-panel-description>
                          Create a new template profile
                        </mat-panel-description>
                      </mat-expansion-panel-header>

                      <mat-form-field class="example-full-width">
                        <mat-label>Template Name</mat-label>
                        <input formControlName="template_name" matInput placeholder="ex.General Template..">
                      </mat-form-field>
                      <br>


                      <mat-form-field class="example-full-width">
                        <mat-label>Description</mat-label>
                        <textarea formControlName="template_description" matInput placeholder="What is this?"></textarea>

                      </mat-form-field>
                      <br>
                      <button type="button" [disabled]="!newTemplateForm.valid" (click)="ngOnsubmit_save_new_template()"
                              color="primary" mat-raised-button>Save
                      </button>

                      <p *ngIf="template_id">({{template_id}}) template is ready, move to the next.</p>
                    </mat-expansion-panel>
                  </mat-accordion> -->
                </div>
                <div>
                  <button type="button" mat-button matStepperNext (click)="addNewTemplate=false">Next</button>
                </div>
              </form>
            </mat-step>
            <mat-step [stepControl]="mapCommandsForm">
              <form [formGroup]="mapCommandsForm">

                <ng-template matStepLabel>Configuration</ng-template>

                <div class="row p-12">
                <div class="col-md-3" >
                  <div  class="m-12" >
                  <!--commands ngxtree-->
                    <app-treeview-systems
                      title="Templates"
                      sort_by = "command_family"
                      (messageSelectedMultipleNodes)="recieve_selected_multiple_items_commands($event)">
                    </app-treeview-systems>

                  </div>
                </div>
                  <div class="login-clean m-auto">
                    <button mat-raised-button color="primary" style="width: 4em; height : 20em;" [disabled]="recieve_selected_items.length == 0" (click)="move_selected_to_list()">
                      <mat-icon>arrow_forward_ios</mat-icon>
                    </button>
                  </div>

                  <div class="col-md-8">
                    <div >
                      <div><h3>Selected Commands List</h3></div>
                      <mat-list class="w-100 treeview-scroller">
                        <hr>
                        <mat-list-item *ngFor="let line of stateGroups; let i = index;">

                          <div mat-line class="mt-2">
                            <mat-icon class="mr-2 text-danger" style="cursor: pointer;" (click)="delete_from_stateGroups(line)">delete</mat-icon>

                              {{line.command_display_name}}

                            <!--                       range-->
                            <mat-slider class="mt-2 ml-2 " *ngIf="line['command_parameters_count']=='range'"

                                        [id]="'command_value_'+line['id']"
                                        thumbLabel
                                        [displayWith]="formatLabel"
                                        tickInterval="1000"
                                        [min]="line['command_min_length']"
                                        [max]="line['command_max_length']"
                                        [(ngModel)]="stateGroups[i].command_value"
                                        [ngModelOptions]="{standalone: true}"></mat-slider>
                                        <mat-form-field
                                          *ngIf="line['command_parameters_count']=='range'"
                                          class="ml-2  example-full-width">
                                          <input matInput
                                          [(ngModel)]="stateGroups[i].command_value"
                                          [ngModelOptions]="{standalone: true}"
                                          maxlength="line['command_max_length'].length"
                                                [placeholder]="line['command_help_text']">
                                        </mat-form-field>
                            <!--                    text -->
                            <mat-form-field
                              *ngIf="line['command_parameters_count']=='text'"
                              class="ml-2  example-full-width">
                              <input matInput [id]="'command_value_'+line['id']"
                              [(ngModel)]="stateGroups[i].command_value"
                              [ngModelOptions]="{standalone: true}"

                                    [placeholder]="line['command_help_text']">
                            </mat-form-field>
                            <!--                      select-->
                            <mat-form-field class="ml-2 " *ngIf="line['command_parameters_count'] =='select'">
                              <mat-label>Click to select</mat-label>
                              <mat-select [id]="'command_value_'+line['id']"
                              [(ngModel)]="stateGroups[i].command_value"
                              [ngModelOptions]="{standalone: true}"

                              >
                                <mat-option *ngFor="let option of line['choices'] " [value]="option['command_choice']">
                                  {{option['command_choice']}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>


                          </div>
                          <mat-list>
                            <mat-list-item>
                              <mat-chip-list class="example-chip text-uppercase" cdkDropList
                                            cdkDropListOrientation="horizontal">
                                <mat-chip cdkDrag>
                                  {{line.software_version}}
                                </mat-chip>
                              </mat-chip-list>
                              <mat-chip-list class="example-chip text-uppercase" cdkDropList
                                            cdkDropListOrientation="horizontal">
                                <mat-chip cdkDrag>
                                  {{line.command_family}}
                                </mat-chip>
                              </mat-chip-list>
                            </mat-list-item>

                          </mat-list>

                        </mat-list-item>


                      </mat-list>
                      <!--                  end-->
                    </div>
                    <button [disabled]="stateGroups.length == 0" class="ml-4" color="primary" mat-button type="button"
                      (click)="stateGroups=[]">Clear list
                    </button>
                    <button [disabled]="stateGroups.length == 0 || !template_id" (click)="prompt_save_commands2()" class="mt-4" data-toggle="modal"
                            data-target="#confrimsavedcommandModal" mat-raised-button color="primary">Add and view list
                    </button>
                    <button mat-button matStepperPrevious>Back</button>
                    <button mat-button matStepperNext>Next</button>

                  </div>
                  <!--   old code
                  <div class="col-md-5">
                    <div [hidden]="SoftwareVersion.value ">
                      <p>please select a software version</p>
                    </div>
                    <div [hidden]="SoftwareVersion.value == null">

                      <form [formGroup]="stateForm">
                        <mat-form-field style="width:90%;">
                          <input
                            id="searchkey"
                            type="text"
                            matInput
                            placeholder="Type a command"
                            formControlName="stateGroup"
                            required

                            [matAutocomplete]="autoGroup">
                          <mat-autocomplete #autoGroup="matAutocomplete">
                            <mat-optgroup *ngFor="let group of stateGroupOptions | async"
                                          label="{{group.CommandFamily}}">
                              <mat-option
                                *ngFor="let name of group.CommandName" [value]="name">
                                {{name}}
                              </mat-option>
                            </mat-optgroup>
                          </mat-autocomplete>

                        </mat-form-field>
                        <button (click)="get_filtered_commands()"
                                color="primary" mat-mini-fab>
                          <mat-icon>search</mat-icon>
                        </button>
                      </form>

                    </div>

                  </div>


                  <div class="col-md-3">

                    <mat-form-field>
                      <mat-label>Software Versions</mat-label>

                      <mat-select [formControl]="SoftwareVersion" multiple>

                        <button matTooltip="select all" color="primary" class="ml-2 mt-2" (click)="check_all()"
                                mat-mini-fab>
                          <mat-icon> select_all</mat-icon>
                        </button>
                        <button matTooltip="deselect all" color="primary" class="ml-2 mt-2" (click)="deselect_all()"
                                mat-mini-fab>
                          <mat-icon> clear_all</mat-icon>
                        </button>
                        <hr>
                        <mat-option *ngFor="let sw of distinct_software_name"
                                    [value]="sw">{{sw.software_version}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div [hidden]="!SoftwareVersion.value" class="col-md-3">
                    <p>Displaying results for: </p>
                    <hr>
                    <mat-chip-list
                      class="example-chip"
                      cdkDropList
                      cdkDropListOrientation="horizontal"
                    >
                      <mat-chip
                        class="example-box"
                        cdkDrag
                        *ngFor="let sw of SoftwareVersion.value">
                        {{sw.software_version}}
                      </mat-chip>
                    </mat-chip-list>
                  </div>
                -->
                </div>




              </form>
            </mat-step>
            <mat-step [stepControl]="createJobForm">
              <form [formGroup]="createJobForm">
                <ng-template matStepLabel>Schedule a Task</ng-template>
                <!--              step body-->
                <div class="row">
                  <div *ngIf="created_job_id" class="col-4">
                    <!--  tree object-->
                    <form>
                      <mat-form-field appearance="fill">
                        <mat-label>Sort tree by</mat-label>
                        <mat-select [(ngModel)]="sort_nav_tree_by" name="item">
                          <mat-option *ngFor="let item of sort_by_list" [value]="item.value">
                            {{item.viewValue}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      </form>
                    <app-treeview-systems
                      title="Location"
                      [sort_by] = sort_nav_tree_by
                      (messageSelectedMultipleNodesWithTheirText)="recieve_selected_multiple_items($event)">
                    </app-treeview-systems>
                  </div>
                  <!-- <div class="login-clean m-auto" *ngIf="created_job_id">
                    <button mat-raised-button color="primary" style="width: 4em; height : 20em;" [disabled]="recieve_selected_items.length == 0" (click)="move_selected_systems_to_task_list()">
                      <mat-icon>arrow_forward_ios</mat-icon>
                    </button>
                  </div> -->
                  <div *ngIf="!created_job_id" class="col-4 ml-3">
                    <h3><i class="fa fa-table text-danger mr-2"></i>Task Configuration</h3>
                    <mat-divider></mat-divider>
                    <!--                  task form-->
                    <mat-form-field class="example-full-width">
                      <mat-label>Title</mat-label>
                      <input matInput formControlName="job_title" placeholder="give it a title">
                    </mat-form-field>
                    <br>
                    
                    <div class="row">
                      <div class="col" style="text-align:left">
                        <input mat-input formControlName="start_job_at" value="dt1.selected" [owlDateTime]="dt1"
                        [owlDateTimeTrigger]="dt1" placeholder="Date Time">
                  <owl-date-time #dt1></owl-date-time>
                      </div>
                      <!-- <div class="col" style="text-align:left">Please use GMT/UTC timezone:<br>{{utctimenow}}</div> -->
                  </div>

                    <br>

                    <mat-form-field>
                      <mat-label>How Often?</mat-label>
                      <mat-select formControlName="template_frequency">
                        <mat-option value="o">Once</mat-option>
                        <mat-option value="d">Daily</mat-option>
                        <mat-option value="w">Weekly</mat-option>
                        <mat-option value="m">Monthly</mat-option>
                        <mat-option value="y">Yearly</mat-option>
                      </mat-select>
                    </mat-form-field>

                  </div>
                  <div *ngIf="created_job_id" class="col-5 ml-3">
                    <h4>
                      <mat-icon class="text-danger">select_all</mat-icon>
                      Select the target system(s) for the created job ({{this.createJobForm.get('job_title').value}})
                    </h4>
                    <mat-divider></mat-divider>

                    <!-- <mat-list *ngIf="list_of_job_selected_systems.length>0 ">
                      <div mat-subheader>{{list_of_job_selected_systems.length}}&nbsp;System/s</div>
                      <mat-list-item *ngFor="let system of list_of_job_selected_systems">
                        <mat-icon mat-list-icon>videocam</mat-icon>
                        <div mat-line>{{system["system_name"]}}</div>

                      </mat-list-item>
                    </mat-list> -->

                    <div style="max-height:75vh;overflow-y:auto;">

                    <table 
                      mat-table [dataSource]="this.recieve_selected_items"
                      class="mat-elevation-z8 col-sm-12">
            
                      <ng-container matColumnDef="deleteIcon" >
                        <th mat-header-cell *matHeaderCellDef class="text-center"></th>
                        <td mat-cell *matCellDef="let element;" class=" text-center">
                            <mat-icon aria-hidden="false" aria-label="delete_forever" matTooltip="Remove"
                          class="deleteSingleRow" style="color: yellowgreen;">computer</mat-icon>
                      </td>
            
                      </ng-container>
            
                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="text-center h4">Selected List - {{this.recieve_selected_items.length}}</th>
                        <td mat-cell *matCellDef="let element;"  class=" text-center">
                          {{element.text}}
                      </td>
                      </ng-container>
            
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                  </div>
                  </div>

                </div>
                <!--        end of step body-->
                <div>
                  <button *ngIf="!created_job_id" [disabled]="!this.createJobForm.valid" (click)="create_template_job()"
                          type="button" mat-raised-button color="primary">
                    Save {{this.createJobForm.get('job_title').value}}</button>
                  <button [disabled]="recieve_selected_items.length==0"
                          *ngIf="created_job_id" (click)="assign_items_to_job();recieve_selected_items = []"
                          type="button" mat-raised-button color="primary">
                    Assign {{recieve_selected_items.length}}
                    System/s to {{this.createJobForm.get('job_title').value}} </button>
                  <button mat-button matStepperPrevious>Back</button>
                  <button mat-button matStepperNext>Next</button>
                </div>
              </form>
            </mat-step>


            <mat-step>
              <ng-template matStepLabel>Done</ng-template>

              <div *ngIf="creation_finished">
                <h3>
                  <mat-icon class="text-success">thumb_up</mat-icon>
                  Perfect, Job: {{this.createJobForm.get('job_title').value}} is ready
                </h3>
                <h3>
                  <mat-icon class="text-success">access_alarms</mat-icon>
                  Next run time at: {{this.createJobForm.get('start_job_at').value}} </h3>
              </div>
              <div *ngIf="creation_finished==false">
                <h3>
                  <mat-icon>error_outline</mat-icon>
                  Please, complete all the the steps..
                </h3>
              </div>
              <div>
                <button mat-button matStepperPrevious>Back</button>
                <button mat-button (click)="stepper.reset()">Reset</button>
              </div>
            </mat-step>
          </mat-horizontal-stepper>


        </div>

      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon text-danger">list_alt</mat-icon>
          Configuration
        </ng-template>


        <div class="row mt-4">
          <!--        tree-->
          <div class="col-sm-3 " [hidden]="slider_addmore || slider_addmore_commands">

            <!--      jobs to template-->
              <app-treeview-systems
                title="Templates"
                [sort_by] = sort_template_tree_by
                [has_checkbox] = "false"
                (messageSelectedNode)="set_template_job_id($event)">
              </app-treeview-systems>
              
          </div>
          <div class="col-sm-3" [hidden]="!slider_addmore">
            <form>
              <mat-form-field appearance="fill">
                <mat-label>Sort tree by</mat-label>
                <mat-select [(ngModel)]="sort_nav_tree_by" name="item">
                  <mat-option *ngFor="let item of sort_by_list" [value]="item.value">
                    {{item.viewValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              </form>
            <app-treeview-systems
              title="Location"
              [sort_by] = sort_nav_tree_by
              
              
              (messageSelectedMultipleNodesWithTheirText)="recieve_selected_multiple_items($event)">
            </app-treeview-systems>

          </div>
          <!--        tabs-->
          <div class="col mt-4">

            <mat-tab-group (selectedTabChange)="click_get_conf_button();" *ngIf="selected_item_job_row != undefined" class="example-stretched-tabs " dynamicHeight>
              <!--            targets list-->


              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon text-danger">timer</mat-icon>
                  Scheduler
                </ng-template>
                <div class="row">
                  <div class="col-6">
                    <mat-card *ngIf="selected_item_job_row != undefined" class="example-card">
                      <mat-card-header>
                        <div mat-card-avatar class="example-header-image"></div>
                        <mat-card-title>{{selected_item_job_row["text"]}}</mat-card-title>
                        <mat-card-subtitle>
                          From: {{selected_item_job_row["value"]["start_job_at"]}}</mat-card-subtitle>
                          <mat-card-subtitle>
                            Job ID: {{selected_item_job_row["value"]["template_job_id"]}}</mat-card-subtitle>
                      </mat-card-header>

                      <mat-card-content>
                        <p>

                        </p>
                      </mat-card-content>
                      <mat-card-actions>
                        <mat-slide-toggle [(ngModel)]="slider_editcurrent_job">Edit Profile</mat-slide-toggle>
                        <br>
                        <mat-slide-toggle [(ngModel)]="show_delete_job">Delete job (no revert)</mat-slide-toggle>
                      </mat-card-actions>
                      <button (click)="delete_job()" [hidden]="!show_delete_job" class="btn btn-danger"><i
                        class="fa fa-trash-alt mr-2"></i>Delete
                        Job
                      </button>
                    </mat-card>

                  </div>
                  <div class="col-6 " [hidden]="!slider_editcurrent_job">
                    <h3>Edit Profile</h3>
                    <hr>
                    <!--                  TODO Insert template here-->
                    <form [formGroup]="updateJobForm">

                      <mat-form-field class="example-full-width">
                        <mat-label>Title</mat-label>
                        <input matInput formControlName="job_title" [ngModel]="selected_item_job_row['text']" placeholder="give it a title">
                      </mat-form-field>
                      <br>


                      <input mat-input formControlName="start_job_at" value="dt1.selected" [owlDateTime]="dt1"
                            [owlDateTimeTrigger]="dt1" placeholder="Date Time">
                      <owl-date-time #dt1></owl-date-time>


                      <br>

                      <mat-form-field>
                        <mat-label>How Often?</mat-label>
                        <mat-select formControlName="template_frequency" [ngModel]="selected_item_job_row['value']['job_frequency']">
                          <mat-option value="o">Once</mat-option>
                          <mat-option value="d">Daily</mat-option>
                          <mat-option value="w">Weekly</mat-option>
                          <mat-option value="m">Monthly</mat-option>
                          <mat-option value="y">Yearly</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-divider></mat-divider>
                      <button [disabled]="!updateJobForm.valid" (click)="ngSubmit_update_job_profile()" mat-raised-button
                              type="button" color="primary">
                        Update job profile
                      </button>
                    </form>

                  </div>
                </div>
              </mat-tab>
              <mat-tab >
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon text-danger">folder</mat-icon>
                  Template target list
                </ng-template>

                <div class="row ">
                  <!-- <div class="login-clean m-auto" [hidden]="!slider_addmore">
                    <button mat-raised-button color="primary" style="width: 4em; height : 20em;" [disabled]="recieve_selected_items.length == 0" (click)="move_selected_systems_to_task_list()">
                      <mat-icon>arrow_forward_ios</mat-icon>
                    </button>
                  </div> -->
                
                  <div class="col " style="max-height:75vh;overflow-y:auto;">

                    <table 
                      mat-table [dataSource]="this.recieve_selected_items"
                      class="mat-elevation-z8 col-sm-12">
            
                      <ng-container matColumnDef="deleteIcon" >
                        <th mat-header-cell *matHeaderCellDef class="text-center"></th>
                        <td mat-cell *matCellDef="let element;" class=" text-center">
                            <mat-icon aria-hidden="false" aria-label="delete_forever" matTooltip="Remove"
                          class="deleteSingleRow" style="color: yellowgreen;">computer</mat-icon>
                      </td>
            
                      </ng-container>
            
                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="text-center h4">New List - {{this.recieve_selected_items.length}}</th>
                        <td mat-cell *matCellDef="let element;"  class=" text-center">
                          {{element.text}}
                      </td>
                      </ng-container>
            
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                  </div>
                  <div class="col " style="max-height:75vh;overflow-y:auto;">

                    <table 
                      mat-table [dataSource]="this.target_systems_list"
                      class="mat-elevation-z8 col-sm-12">
            
                      <ng-container matColumnDef="deleteIcon" >
                        <th mat-header-cell *matHeaderCellDef class="text-center"></th>
                        <td mat-cell *matCellDef="let element;" class=" text-center">
                            <mat-icon aria-hidden="false" aria-label="delete_forever" matTooltip="Remove"
                          class="deleteSingleRow" style="color: yellowgreen;">computer</mat-icon>
                      </td>
            
                      </ng-container>
            
                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="text-center h4"  >Saved List - {{this.target_systems_list.length}}</th>
                        <td mat-cell *matCellDef="let element;"  class=" text-center">
                          {{element.system_name}} - {{element.system_ip}}
                      </td>
                      </ng-container>
            
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                  </div>
                  <div class="col ">
                    <!--                 options div-->
                    <mat-slide-toggle  matTooltip="click to show the navigator tree" [(ngModel)]="slider_addmore"
                                      class="mt-4">Switch to Navigator
                    </mat-slide-toggle>
                    <br>
                    <button
                      (click)="recieve_selected_items=[]"
                      class="mt-4"
                      matTooltip="click to clear systems list" type="button" mat-raised-button color="primary">
                      Clear list
                    </button>
                    <br>
                    <button
                      (click)="ngSubmit_save_job_config_system_changes()"
                      class="mt-4"
                      matTooltip="click to save changes" type="button" mat-raised-button color="primary">
                      Save <mat-icon>save</mat-icon>
                    </button>


                  </div>
                </div>
              </mat-tab>
              <!--           settings list-->

              <mat-tab >
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon text-danger">format_list_bulleted</mat-icon>
                  Saved Commands
                </ng-template>
                <form [formGroup]="mapCommandsForm">
                  <div class="row">
                    <div class="col-md-12 p-4">
                      <!--                    saved commands list-->


                      <app-sql-data-table
                        class="p-4"
                        query="select command_display_name,command_value,command_family,command_sw_version,b.id as 'command_id',a.id  as 'command_conf_id' from vms.templatemanager_templatecommandmappings a inner join system_overview_systemclicommands b on a.command_id_fk = b.id"
                        hidden_cols="command_id,command_conf_id"
                        condition="true"
                        condition_key="template_name_id"
                        [condition_value]="selected_item_template_id"
                        condition_value_type="number"
                        ischeckbox="false"
                        show_action_button="true"
                        action_button_title="Get Configuration\Refresh"
                        (messageEvent)="get_selected_sql_row($event)"
                      >

                      </app-sql-data-table>
                    </div>
                    <div class="col-sm-6">
                      <!--                    empty column-->

                    </div>


                  </div>


                </form>


              </mat-tab>
              <!--   history-->
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon text-danger">history</mat-icon>
                  Template History
                </ng-template>
                <app-sql-data-table
                  query="select  job_name,operation_title,operation_request,operation_response,created_at from templatemanager_templatejobslog tbllogs inner join templatemanager_templatecreatejob tbljobs on tbllogs.job_id = tbljobs.template_job_id"
                  condition="true"
                  condition_key="tbljobs.id"
                  [condition_value]="selected_item_job_id"
                  condition_value_type="int"
                  hidden_cols="id"
                  ischeckbox="false"
                  show_action_button="true"
                  action_button_title="Refresh Logs"

                ></app-sql-data-table>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>


  </div>

  <button id="modal_sql_row" type="button" hidden="true" class="btn btn-primary" data-toggle="modal"
          data-target="#editsavedcommandModal">
    hiddenbutton sql row
  </button>
  <!-- Modal -->
  <div class="modal fade" id="editsavedcommandModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel3">Edit Command</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h1>Current Configuration</h1>
          <hr>
          <h3>{{selected_sql_row['command_display_name']}} : {{selected_sql_row['command_value']}}</h3>
          <h3>Family: {{selected_sql_row['command_family']}}</h3>
          <h5>Software Version: {{selected_sql_row['command_sw_version']}}</h5>
          <mat-checkbox [(ngModel)]="switcher_deletecommand">Delete this template-command mapping (No revert)
          </mat-checkbox>
          <hr>
          <h1>Modify current value </h1>
          <hr>
          <form [formGroup]="modal_modifyCommandConfForm">
            <mat-list-item *ngFor="let list_item of modal_edit_command_conf">

              <div mat-line class="p-4">


                <i class="fa fa-plus text-danger mr-2"></i>
                <span class="mr-4">{{list_item['command_props']['command_display_name']}}</span>
                <input type="hidden" formControlName="id" [value]="selected_sql_row['command_conf_id']">
                <input type="hidden" formControlName="command_value_type">

                <!--                       range-->
                <mat-slider *ngIf="list_item['command_props']['command_parameters_count'] =='range'"
                            formControlName="command_value"
                            thumbLabel
                            [displayWith]="formatLabel"
                            tickInterval="1000"
                            [min]="list_item['command_props']['command_min_length']"
                            [max]="list_item['command_props']['command_max_length']"></mat-slider>
                <!--                    text -->
                <mat-form-field
                  *ngIf="list_item['command_props']['command_parameters_count'] =='text'"
                  class="example-full-width">

                  <input matInput formControlName="command_value"
                        [placeholder]="list_item['command_props']['command_help_text']">

                </mat-form-field>
                <!--                      select-->
                <select *ngIf="list_item['command_props']['command_parameters_count'] =='select'"
                        formControlName="command_value" name="">
                  <option *ngFor="let option of list_item['choices'] " [value]="option"> {{option}}</option>
                </select>

                <!--                      remove icon-->
                <!--                    <i (click)="delete_from_list(list_item)" class="fa fa-trash text-danger fa-pull-right"></i>-->
              </div>

              <mat-divider></mat-divider>

            </mat-list-item>
          </form>


        </div>
        <div class="modal-footer">
          <button style="float: left" matTooltip="cannot be undone"
                  [disabled]="!switcher_deletecommand"
                  (click)="delete_template_command_conf(selected_sql_row['command_conf_id'])"
                  class=" btn btn-danger fa-pull-left"><i class="fa fa-trash-alt"></i>Delete Command
          </button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" (click)="ngSubmit_save_modified_template_command();click_get_conf_button();" class="btn btn-primary"
                  [disabled]="!this.modal_modifyCommandConfForm.valid" data-dismiss="modal">Save changes
          </button>

        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="confrimsavedcommandModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel1">Confirm commands</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h1>You have selected {{selected_commands_list.length}} command(s)</h1>
          <p class="text-danger" *ngIf="!template_id">
            <mat-icon class="text-danger mr-2">close</mat-icon>
            please select a template first.
          </p>
          <hr>
          <p *ngIf="selected_commands_list.length ==0 ">Please, select one or more commands.
            <button type="button" class="btn btn-secondary" data-dismiss="modal">go back</button>
          </p>
          <ol>
            <li class="text-dark" *ngFor="let row of selected_commands_list">
              <mat-icon class="mr-2 text-danger" (click)="delete_from_selected_commands_list(row)">delete</mat-icon>
                                <mat-chip>{{row.command_family}}</mat-chip>
                                <mat-chip>{{row.command_sw_version_text}}</mat-chip>
              {{row.command_syntax}}: <b>{{row.command_value}}</b></li>
          </ol>

        </div>
        <div class="modal-footer">

          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary"
                  data-dismiss="modal"
                  [disabled]="selected_commands_list.length == 0 || !template_id"
                  (click)="prompt_assign_command_to_template()"
          >Save changes
          </button>

        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!user_access_obj.includes(user_info_obj['role'])">
  <article>
    <header>
      <h1>403<i class="fa fa-exclamation-triangle fa-fw"></i></h1>
    </header>
    <p>Access Denied</p>
  </article>
</div>
